import {Fragment} from 'react';
import clsx from 'clsx';
import {getDetail} from '../utils';

import styles from './styles.module.scss';

export const FileDetails = props => {
  const data = getDetail(props);

  return (
    <div className={styles.container}>
      {data.map((group) => (
        <Fragment key={group.name}>
          <h4 className="font-semibold py-2">{group.name}</h4>
          {group.items.map((item, index) => (
            <div
              className={clsx(styles.row, 'grid grid-cols-2 h-full items-center gap-x-2 pl-4')}
              key={item.name + index}>
              <span className="py-1">{`${item.name}${item.name ? ':' : ''}`}</span>
              <span className="uppercase break-words">{item.value}</span>
            </div>
          ))}
        </Fragment>
      ))}
    </div>
  );
};
